/*global angular*/

var searchResult = angular.module('searchResult', []);
searchResult.directive('searchResult', [function () {
  'use strict';
  return {
    restrict: 'E',
    template: require('./searchResult.html'),
    replace: false,
    transclude: false,
    scope: {
      result: '<'
    },
    link: function (scope, element, attrs) {
      /**
       * The case of search results is different to practical examples, as we only...
       * ... show paragraphs here if there's no description in the search result context.
       */
      scope.showParagraphsInSearchResults = function () {
        var result = scope.result;
        return result.context && result.context.paragraphs && result.context.paragraphs.length > 0 && !result.context.description;
      };
    }
  };
}]);
module.exports = searchResult;



// WEBPACK FOOTER //
// ./web/js/module/searchResult/searchResult.js